export const ContentId = {
  None: 'None',
  Users: 'Users',
  AppSettings: 'AppSettings'
};

export const SET_CONTENT = '@@SETTINGS_SET_CONTENT';
